import React, { useEffect } from "react";
import useTimer from "./useTimer";

const OtpTimer = ({handleResend, isSending}) => {
  const { formattedTime, startTimer, canResend } = useTimer(60);
  useEffect(() => {
    startTimer();
  }, []);

  const resend = () => {
    if (!canResend) return;
    handleResend();
  };

  return (
    <a
      href="#"
      onClick={resend}
      className={`action-link ${
        !canResend || isSending ? "disabled" : ""
      } ${canResend ? "resend-active" : ""}`}
    >
      {canResend ? "Resend OTP" : `Resend in ${formattedTime}`}
    </a>
  );
};

export default OtpTimer;
